import { Card, List } from 'antd';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import RoleGuard from '../../auth/RoleGuard';
import { REPORTS } from '../../constants/reports';

export default function ReportsHome() {
  const { hasRole } = useAuth();
  const reports = REPORTS.filter((report) => hasRole(report.roles));
  return (
    <RoleGuard allow={[...new Set(REPORTS.flatMap((report) => report.roles))]}>
      <Card title="گزارش‌ها">
        <List dataSource={reports} renderItem={(report) => (
          <List.Item><Link to={`/reports/${report.type}`}>{report.title}</Link></List.Item>
        )} />
      </Card>
    </RoleGuard>
  );
}
